<template>
  <nav v-if="$vuetify.breakpoint.smAndUp">
    <v-container class="pa-0">
      <v-toolbar class="px-0 elevation-0 background">
        <v-spacer></v-spacer>
        <v-toolbar-title>
          <router-link :to="{ name: $constants.ROUTE_NAME.HOME }"><v-img src="@/assets/oly-logo.png" /></router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="nav-auth-container d-flex">
          <v-progress-circular v-if="userIsLoading" indeterminate color="primary" />
          <template v-else>
            <v-btn link text class="text-capitalize no-letter-spacing" @click.prevent="openLoginDialog">{{ $t('label.login') }}</v-btn>
            <v-divider vertical class="black my-1" />
            <v-btn link text @click.prevent="openSignUpDialog" class="text-capitalize no-letter-spacing">{{ $t('label.signUp') }}</v-btn>
          </template>
        </div>
      </v-toolbar>
    </v-container>
  </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('auth', ['userIsLoading'])
  },

  methods: {
    openLoginDialog() {
      this.$root.$app.openLoginDialog()
    },
    openSignUpDialog() {
      this.$root.$app.openSignUpDialog()
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-auth-container {
  position: absolute;
  right: 0;
  min-width: 3rem; // for progress spinner
}
</style>
